"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCESS_TYPES = exports.ROLES = exports.SCOPES = exports.ERRORS = exports.ALL_PIPELINES_SELECTED = exports.ALL_TEAMS_SELECTED = exports.PERIOD_UNITS_TO_SKIP = exports.PERIOD_UNIT_TO_MOMENT_SINGULAR = exports.PERIOD_UNIT_TO_MOMENT = exports.NUM_PER_PERIOD = exports.QUOTA_PERIODS = exports.QUOTA_TYPE_GROUP_MAP = exports.QUOTA_TYPE_GROUPS = exports.QUOTA_TYPES = exports.LOCAL_STORAGE_KEYS = exports.TICKET_OBJECT_TYPE = exports.DEAL_OBJECT_TYPE = exports.QUOTAS_ROUTE = exports.NUM_BASIC_GOAL_MONTHS = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var NUM_BASIC_GOAL_MONTHS = 24;
exports.NUM_BASIC_GOAL_MONTHS = NUM_BASIC_GOAL_MONTHS;
var QUOTAS_ROUTE = 'goals';
exports.QUOTAS_ROUTE = QUOTAS_ROUTE;
var DEAL_OBJECT_TYPE = 'DEAL';
exports.DEAL_OBJECT_TYPE = DEAL_OBJECT_TYPE;
var TICKET_OBJECT_TYPE = 'TICKET';
exports.TICKET_OBJECT_TYPE = TICKET_OBJECT_TYPE;
var LOCAL_STORAGE_KEYS = {
  LAST_QUOTA_TYPE: "LastQuotaType:" + _hubspot.default.get()
};
exports.LOCAL_STORAGE_KEYS = LOCAL_STORAGE_KEYS;
var QUOTA_TYPES = (0, _keyMirror.default)({
  AVERAGE_TICKET_RESOLUTION_TIME: null,
  AVERAGE_TICKET_RESPONSE_TIME: null,
  CALLS_MADE: null,
  DEALS_CREATED: null,
  MEETINGS_BOOKED: null,
  REVENUE: null,
  TICKETS_CLOSED: null
});
exports.QUOTA_TYPES = QUOTA_TYPES;
var QUOTA_TYPE_GROUPS = (0, _keyMirror.default)({
  SALES: null,
  SERVICES: null
});
exports.QUOTA_TYPE_GROUPS = QUOTA_TYPE_GROUPS;
var QUOTA_TYPE_GROUP_MAP = {
  TICKETS_CLOSED: QUOTA_TYPE_GROUPS.SERVICES,
  AVERAGE_TICKET_RESOLUTION_TIME: QUOTA_TYPE_GROUPS.SERVICES,
  AVERAGE_TICKET_RESPONSE_TIME: QUOTA_TYPE_GROUPS.SERVICES,
  CALLS_MADE: QUOTA_TYPE_GROUPS.SALES,
  DEALS_CREATED: QUOTA_TYPE_GROUPS.SALES,
  MEETINGS_BOOKED: QUOTA_TYPE_GROUPS.SALES,
  REVENUE: QUOTA_TYPE_GROUPS.SALES
};
exports.QUOTA_TYPE_GROUP_MAP = QUOTA_TYPE_GROUP_MAP;
var QUOTA_PERIODS = (0, _keyMirror.default)({
  WEEKLY: null,
  MONTHLY: null,
  QUARTERLY: null,
  ANNUALLY: null
});
exports.QUOTA_PERIODS = QUOTA_PERIODS;
var NUM_PER_PERIOD = {
  WEEKLY: 4,
  MONTHLY: 12,
  QUARTERLY: 4,
  ANNUALLY: 3
};
exports.NUM_PER_PERIOD = NUM_PER_PERIOD;
var PERIOD_UNIT_TO_MOMENT = {
  WEEKLY: 'weeks',
  MONTHLY: 'months',
  QUARTERLY: 'quarters',
  ANNUALLY: 'years'
};
exports.PERIOD_UNIT_TO_MOMENT = PERIOD_UNIT_TO_MOMENT;
var PERIOD_UNIT_TO_MOMENT_SINGULAR = {
  WEEKLY: 'week',
  MONTHLY: 'month',
  QUARTERLY: 'quarter',
  ANNUALLY: 'year'
};
exports.PERIOD_UNIT_TO_MOMENT_SINGULAR = PERIOD_UNIT_TO_MOMENT_SINGULAR;
var PERIOD_UNITS_TO_SKIP = {
  WEEKLY: 1,
  MONTHLY: 12,
  QUARTERLY: 1,
  ANNUALLY: 1
};
exports.PERIOD_UNITS_TO_SKIP = PERIOD_UNITS_TO_SKIP;
var ALL_TEAMS_SELECTED = null;
exports.ALL_TEAMS_SELECTED = ALL_TEAMS_SELECTED;
var ALL_PIPELINES_SELECTED = null;
exports.ALL_PIPELINES_SELECTED = ALL_PIPELINES_SELECTED;
var ERRORS = (0, _keyMirror.default)({
  GET_QUOTAS: null,
  SAVE_QUOTAS: null,
  DELETE_QUOTAS: null,
  GET_OWNERS: null,
  GET_PIPELINES: null
});
exports.ERRORS = ERRORS;
var SCOPES = {
  LEGACY_QUOTAS_ACCESS: 'legacy-quotas-access',
  QUOTAS_WRITE: 'quotas-write',
  BASIC_SALES_GOAL_MANAGER: 'basic-sales-goal-manager',
  ADVANCED_SALES_GOAL_MANAGER: 'advanced-sales-goal-manager',
  ADVANCED_SERVICE_GOAL_MANAGER: 'advanced-service-goal-manager',
  IS_SALES_PROFESSIONAL: 'is-sales-professional',
  IS_LEGACY_SALES_PRO: 'is-legacy-sales-pro',
  ADVANCED_SALES_GOAL_ASSIGNMENT: 'advanced-sales-goal-assignment',
  ADVANCED_SERVICES_GOAL_ASSIGNMENT: 'advanced-services-goal-assignment',
  SALES_GOAL_ASSIGNMENT: 'sales-goal-assignment',
  LEGACY_SALES_GOAL_ASSIGNMENT: 'legacy-sales-goal-assignment'
};
exports.SCOPES = SCOPES;
var ROLES = {
  SUPER_ADMIN: 'super-admin',
  ELEVATED_JITA: 'elevated-jita',
  SALES_ENTERPRISE: 'sales-enterprise',
  SERVICE_ENTERPRISE: 'service-enterprise',
  SALES_PRO: 'sales-pro',
  SALES_STARTER: 'sales-starter'
};
exports.ROLES = ROLES;
var ACCESS_TYPES = (0, _keyMirror.default)({
  ADVANCED_SALES: null,
  ADVANCED_SERVICE: null,
  ADVANCED_SERVICE_WITH_REVENUE: null,
  ADVANCED_BOTH: null,
  BASIC_SALES: null,
  LEGACY: null,
  NONE: null
});
exports.ACCESS_TYPES = ACCESS_TYPES;